import {
  PSelect,
  PSelectOption,
  PSelectProps,
} from '@porsche-design-system/components-react';

enum Format {
  'DD.MM.YYYY' = 'DD.MM.YYYY',
  'DD/MM/YYYY' = 'DD/MM/YYYY',
  'MM/DD/YYYY' = 'MM/DD/YYYY',
  'YYYY/MM/DD' = 'YYYY/MM/DD',
  'YYYY-MM-DD' = 'YYYY-MM-DD',
  'YYYY.MM.DD' = 'YYYY.MM.DD',
  'YYYY.DD.MM' = 'YYYY.DD.MM',
}

type DateFormatSelectProps = Omit<PSelectProps, 'name'> &
  Pick<React.SelectHTMLAttributes<HTMLSelectElement>, 'defaultValue'>;

export const DateFormatSelect = ({
  defaultValue,
  ...props
}: DateFormatSelectProps) => (
  <PSelect
    name="dateFormat"
    {...props}
    value={String(props.value ?? defaultValue)}
    aria-label={props.label}
  >
    {Object.values(Format).map((format) => (
      <PSelectOption key={format} value={format}>
        {format}
      </PSelectOption>
    ))}
  </PSelect>
);
